/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { SugarCooker } from "./modelSugarCooker";

class ControllerSugarCooker extends ControllerModel {
    constructor() {
        super("ControllerSugarCooker");

        this.setNewNode = (callback) => {
            let sugarCooker = new SugarCooker();
            sugarCooker.decorate(callback);

            this.addNode(sugarCooker);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let sugarCooker = new SugarCooker();
            sugarCooker.copyFrom(node);
            sugarCooker.decorate(callback);
            this.addNode(sugarCooker)
        }

        this.getProperties = async (node) => {
            let n = new SugarCooker();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new SugarCooker();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerSugarCooker };